import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg my-2 font-semibold" }, "Loaders", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Admin Details", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg my-2 font-semibold" }, "All School Admins", -1)

import { useAdminStore } from "@/stores/adminStore";
import { onBeforeMount } from "vue";
import { useSchoolStore } from "@/stores/schoolStore";
import { useNoticeStore } from "@/stores/noticeStore";

const adminId = "iySoD77YAFSSOq2TnYbWCxO5Uzf1";


export default /*#__PURE__*/_defineComponent({
  __name: 'SuperAdmin',
  setup(__props) {

const adminStore = useAdminStore();
const schoolStore = useSchoolStore();
const noticeStore = useNoticeStore();

onBeforeMount(async () => {
  await adminStore.fetchAllSchoolAdmins(
    schoolStore.currentSchool?._id as string
  );
  await adminStore.fetchAdminById(adminId);

  await noticeStore.fetchNotices(schoolStore.currentSchool?._id as string);
});

async function updateAdmin() {
  const adminDetails = {
    designation: "Updated Class Teacher",
  };

  await adminStore.updateAdminDetails(adminId, adminDetails);
}

async function createAdmin() {
  const newAdmin = {
    firstName: "Tiro",
    lastName: "Teacher 5",
    email: "tiro+5@reflectivelearning.co.za",
    designation: "Class Teacher",
    status: "inactive",
    roles: [],
    school: schoolStore.currentSchool?._id as string,
  };

  await adminStore.createNewAdmin(newAdmin);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("p", null, "Loading Message: " + _toDisplayString(_unref(adminStore).loadingMessage), 1),
      _createElementVNode("pre", null, _toDisplayString(_unref(adminStore).loader), 1)
    ]),
    (_unref(adminStore).currentAdmin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "rounded-md bg-blue-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600",
            onClick: updateAdmin
          }, " Update Admin Details "),
          _hoisted_3,
          _createElementVNode("div", null, [
            _createElementVNode("pre", null, _toDisplayString(_unref(adminStore).currentAdmin), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        type: "button",
        class: "rounded-md bg-blue-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600",
        onClick: createAdmin
      }, " Create New Admin "),
      _hoisted_4,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(adminStore).admins, (admin) => {
          return (_openBlock(), _createElementBlock("li", {
            key: admin._id
          }, _toDisplayString(admin.firstName) + " " + _toDisplayString(admin.lastName) + " - " + _toDisplayString(admin.email), 1))
        }), 128))
      ])
    ])
  ]))
}
}

})